(function(){
       'use strict'; 
    $(document).ready(function() {
            function convert_currency(value,type){
                var newCurrency = Currency.currentCurrency;
                var oldCurrency = shopCurrency;
                if(isNaN(value)){
                    value =  0.0;
                }

                var cents = 0.0;
                var oldFormat = Currency.moneyFormats['USD'][ Currency.format] || '';
                var newFormat = Currency.moneyFormats[newCurrency][Currency.format] || '';
                if (oldFormat.indexOf('amount_no_decimals') !== -1) {
                    cents = Currency.convert(parseInt(value, 10)*100, oldCurrency, newCurrency);
                    console.log(11);
                }
                else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
                    cents = Currency.convert(parseInt(value, 10)/10, oldCurrency, newCurrency);
                    console.log(22);
                }
                else { 
                    cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
                }
                if(type  == 'nosymbol'){
                    return cents;
                }
                var my_data =  Currency.formatMoney(cents, newFormat);
                return my_data;
        
       
      }
        $("#slider-range").slider({ 
            range: true,
            min: 50,
            max: 900,
            values: [50, 900],
            slide: function(event, ui) {
                $("#amount").val(Currency.currentCurrency +" " + ui.values[0] + " - "  + Currency.currentCurrency + " "+ ui.values[1]);
            },
            change: function(event, ui) {
                $("#loading").show(400);
                var max_price = ui.values[1];
                var min_price = ui.values[0];
                var check = 1;
                $("#list-product").empty();
          	var view = $(".change-view--active").data('view');
          var html = '';
                $.each(json_collectionx,function(index, elem) {
                    if (check <= 10) {
                        var current_price =  convert_currency(elem.price,'');
                        current_price = parseInt(current_price.replace(/[^0-9.]/g, ''));
                     //   console.log(current_price);
                        if (current_price <= max_price && current_price >= min_price) {
                              console.log(current_price);
                              if(view  == 'list'){
                             html = html +    search_html(elem);
                            }else{
                              html = html +     search_grid(elem);
                            }
                            
                        }
                    }
                    check++;
                });
          $('[data-toggle=\'tooltip\']').tooltip({
            container: 'body'
          });
                $("#list-product").html(html);
                window.setTimeout(function() {
                    $("#loading").hide(400);
                }, 1000);
            } 
        });
        function search_grid(data) {
          var  is_sale = false;
          if(data.compare_at_price > data.price){is_sale =true}
          var $html = '<div class="col-md-3 col-sm-6 col-xs-12">';
          $html= $html +'<div class="product-item">' ;
          
          if(is_sale){
            $html  = $html + '<span class="sale-box">';
            $html = $html + '<span class="label-sale product-label">Sale</span>';
            $html  = $html + '</span>';
          }
          
          $html = $html+ '<div class="product-image"><a href="/products/'+data.handle+'" title="'+ data.title +'"> <figure class="image-visible">';
          $html = $html + '<img src="'+data.images[0]+'" /> </figure></a> </div>'
          $html = $html + '<div class="product-overlay"><div class="product-quick-view">';
          $html = $html + '<a href="#" data-toggle="tooltip" data-placement="top" data-pid="'+data.variants[0].id+'" onclick="location.href=\"/products/'+data.handle+'\" title="Select Options" data-original-title="Select Options"><i class="fa fa-ellipsis-h"></i></a>';
		  $html = $html + '<a class="wishlist-login" href="javascript:void(0)" title="" data-pid="'+data.variants[0].id+'" data-toggle="tooltip" data-placement="top" data-original-title="Login to use wishlist" title="Login to use wishlist"><i class="fa fa-heart-o"></i> '+data.title+'</a>';
          $html = $html + '<a href="#" data-toggle="tooltip" data-placement="top" class="compare" data-pid="'+data.handle+'" title="" data-original-title="Compare product"><i class="fa fa-refresh"></i></a>';
          $html = $html +'</div></div>';
          $html = $html + '<div class="product-text"><h2><a class="product-title" href="/products/'+data.handle+'" title="">'+data.title+' </a></h2>';
          $html =  $html + ' <div class="product-price  "> <span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(data.price,'xx')+'">'+convert_currency(data.price,'11')+'</span>';
          	 if(convert_currency(data.compare_at_price,'nosymbol') > 0){

          $html =  $html +  ' <s><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(data.compare_at_price,'11')+'">'+convert_currency(data.compare_at_price)+'</span></s>';
          
             }
               $html =  $html + '</div></div></div></div>';
          
          
             return $html;
        }
        function search_html(data){
          var  is_sale = false;
            if(data.compare_at_price > data.price){is_sale =true}
          var $html ='<div class="col-md-4 col-sm-6 col-xs-12">';
          $html = $html +'<div class="image-container">';
          $html=$html+'<a href="/products/'+data.handle+'" title="'+ data.title +'" class="thumbnail">';
          $html=$html+'<img src="'+data.images[0]+'" class="product-image" />';
          $html=$html+'</a></div></div>';
          $html=$html+'<div class="col-md-8 col-sm-6 col-xs-12">';
          $html=$html+' <a href="/products/'+data.handle+'" class="product-link"><h2 class="product-name">'+data.title+'</h2></a>';
          $html=$html+'<div class="product-rating">';
          $html=$html+'</div>';
           $html =  $html + ' <div class="product-price  "> <span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(data.price,'xx')+'">'+convert_currency(data.price,'11')+'</span>';
          	 if(convert_currency(data.compare_at_price,'nosymbol') > 0){

          $html =  $html +  ' <s><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(data.compare_at_price,'11')+'">'+convert_currency(data.compare_at_price)+'</span></s>';
          
             }
           $html =  $html + '</div>';
          $html = $html +'<div class="product-description"><p>'+data.description+'</p></div>';
           $html = $html + '<div class="product-ovelay">';
          $html = $html + '<a href="#" data-toggle="tooltip" data-placement="top" data-pid="'+data.variants[0].id+'" onclick="location.href=\"/products/'+data.handle+'\" title="" data-original-title="Select Options"><i class="fa fa-ellipsis-h"></i></a>';
		  $html = $html + '<a class="wishlist-login" href="javascript:void(0)" data-pid="'+data.variants[0].id+'" title="" data-toggle="tooltip" data-placement="top" data-original-title="Login to use wishlist"><i class="fa fa-heart-o"></i> '+data.title+'</a>';
          $html = $html + '<a href="#" data-toggle="tooltip" data-placement="top" class="compare" data-pid="'+data.handle+'" title="" data-original-title="Compare product"><i class="fa fa-refresh"></i></a>';
          $html = $html +'</div></div>';
         $html = '<div class="search_item item-list"> '+$html+'  </div>';
             return $html;
        }
        $("#amount").val(Currency.currentCurrency + " " + $("#slider-range").slider("values", 0) + " - " + Currency.currentCurrency +" "+ $("#slider-range").slider("values", 1));
        
        });
    })(jQuery);